import { addDatadogError } from "@utils/datadogRum";

interface NoticeErrorProps {
  err: unknown;
  customAttributes?: Record<string, any>;
}

export const noticeError = ({
  err,
  customAttributes = {},
}: NoticeErrorProps) => {
  if (typeof window !== "undefined") {
    addDatadogError(err, customAttributes);
    return;
  }

  const normalizedError =
    err instanceof Error ? err : new Error(typeof err === "string" ? err : "Unknown error");

  console.error("Datadog noticeError fallback", normalizedError, customAttributes);
};
